import axios from 'axios';

export const createOrder = (params = {}) => axios.post('/orders', params);

export const validateOrder = (params = {}) => axios.post('/orders/validate', params);
